import React from 'react';
import PropTypes from 'prop-types';
export { default as Checkbox } from './Checkbox';

const CheckboxGroup = props => {
	const { children, name, onChange, values, ...rootProps } = props;
	const isControlled = 'values' in props;
	const inputs = [];

	return (
		<div {...rootProps}>
			{React.Children.map(children, checkbox => {
				let childProps = {
					name,
					onChange: handleChange,
					inputRef: node => inputs.push(node),
				};

				if (isControlled) {
					childProps = {
						...childProps,
						checked: values.includes(checkbox.props.value),
					};
				}

				return React.cloneElement(checkbox, childProps);
			})}
		</div>
	);

	function handleChange() {
		const checkedValues = inputs
			.filter(input => input.checked)
			.map(input => input.value);

		onChange(checkedValues);
	}
};

CheckboxGroup.propTypes = {
	onChange: PropTypes.func,
	values: PropTypes.array,
};

CheckboxGroup.defaultProps = {
	onChange: () => {},
};

export default CheckboxGroup;
